"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    // 统计广告申请
    apply_ads: {
        params: {
            lt: 'event',
            e_c: 'native_ads',
            e_a: 'apply',
            e_n: 'applyads',
            wmPeopleId: '~people_id',
            wmPeopleName: '~people_name',
            articleId: '~article_id',
            articleTitle: '~title',
        },
    },
    // 统计广告拉取成功
    pull_ads: {
        params: {
            lt: 'event',
            e_c: 'native_ads',
            e_a: 'pull',
            e_n: 'pullads',
            wmPeopleId: '~people_id',
            wmPeopleName: '~people_name',
            articleId: '~article_id',
            articleTitle: '~title',
        },
    },
    // 统计广告曝光
    show_ads: {
        params: {
            lt: 'event',
            e_c: 'native_ads',
            e_a: 'show',
            e_n: 'showads',
            wmPeopleId: '~people_id',
            wmPeopleName: '~people_name',
            articleId: '~article_id',
            articleTitle: '~title',
        },
    },
    // 统计完整广告曝光
    show_ads_complete: {
        params: {
            lt: 'event',
            e_c: 'native_ads',
            e_a: 'show',
            e_n: 'showadscomplete',
            wmPeopleId: '~people_id',
            wmPeopleName: '~people_name',
            articleId: '~article_id',
            articleTitle: '~title',
        },
    },
    // 统计广告点击
    click_ads: {
        params: {
            lt: 'link',
            ck_rg: 'native_ads',
            ck_po: 'click_to_ads',
            wmPeopleId: '~people_id',
            wmPeopleName: '~people_name',
            articleId: '~article_id',
            articleTitle: '~title',
        },
    },
    // 统计广告拉取失败
    fail_ads: {
        params: {
            lt: 'event',
            e_c: 'native_ads',
            e_a: 'fail',
            e_n: 'failads',
            wmPeopleId: '~people_id',
            wmPeopleName: '~people_name',
            articleId: '~article_id',
            articleTitle: '~title',
        },
    },
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RhdFJ1bGVOYXRpdmUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJzdGF0UnVsZU5hdGl2ZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUFBLGtCQUFlO0lBQ1gsU0FBUztJQUNULFNBQVMsRUFBRTtRQUNWLE1BQU0sRUFBRTtZQUNOLEVBQUUsRUFBRSxPQUFPO1lBQ1gsR0FBRyxFQUFFLFlBQVk7WUFDakIsR0FBRyxFQUFFLE9BQU87WUFDWixHQUFHLEVBQUUsVUFBVTtZQUNmLFVBQVUsRUFBRSxZQUFZO1lBQ3hCLFlBQVksRUFBRSxjQUFjO1lBQzVCLFNBQVMsRUFBRSxhQUFhO1lBQ3hCLFlBQVksRUFBRSxRQUFRO1NBQ3ZCO0tBQ0Y7SUFDRCxXQUFXO0lBQ1gsUUFBUSxFQUFFO1FBQ1IsTUFBTSxFQUFFO1lBQ04sRUFBRSxFQUFFLE9BQU87WUFDWCxHQUFHLEVBQUUsWUFBWTtZQUNqQixHQUFHLEVBQUUsTUFBTTtZQUNYLEdBQUcsRUFBRSxTQUFTO1lBQ2QsVUFBVSxFQUFFLFlBQVk7WUFDeEIsWUFBWSxFQUFFLGNBQWM7WUFDNUIsU0FBUyxFQUFFLGFBQWE7WUFDeEIsWUFBWSxFQUFFLFFBQVE7U0FDdkI7S0FDRjtJQUNELFNBQVM7SUFDVCxRQUFRLEVBQUU7UUFDUixNQUFNLEVBQUU7WUFDTixFQUFFLEVBQUUsT0FBTztZQUNYLEdBQUcsRUFBRSxZQUFZO1lBQ2pCLEdBQUcsRUFBRSxNQUFNO1lBQ1gsR0FBRyxFQUFFLFNBQVM7WUFDZCxVQUFVLEVBQUUsWUFBWTtZQUN4QixZQUFZLEVBQUUsY0FBYztZQUM1QixTQUFTLEVBQUUsYUFBYTtZQUN4QixZQUFZLEVBQUUsUUFBUTtTQUN2QjtLQUNGO0lBQ0QsV0FBVztJQUNYLGlCQUFpQixFQUFFO1FBQ2pCLE1BQU0sRUFBRTtZQUNOLEVBQUUsRUFBRSxPQUFPO1lBQ1gsR0FBRyxFQUFFLFlBQVk7WUFDakIsR0FBRyxFQUFFLE1BQU07WUFDWCxHQUFHLEVBQUUsaUJBQWlCO1lBQ3RCLFVBQVUsRUFBRSxZQUFZO1lBQ3hCLFlBQVksRUFBRSxjQUFjO1lBQzVCLFNBQVMsRUFBRSxhQUFhO1lBQ3hCLFlBQVksRUFBRSxRQUFRO1NBQ3ZCO0tBQ0Y7SUFDRCxTQUFTO0lBQ1QsU0FBUyxFQUFFO1FBQ1QsTUFBTSxFQUFFO1lBQ04sRUFBRSxFQUFFLE1BQU07WUFDVixLQUFLLEVBQUUsWUFBWTtZQUNuQixLQUFLLEVBQUUsY0FBYztZQUNyQixVQUFVLEVBQUUsWUFBWTtZQUN4QixZQUFZLEVBQUUsY0FBYztZQUM1QixTQUFTLEVBQUUsYUFBYTtZQUN4QixZQUFZLEVBQUUsUUFBUTtTQUN2QjtLQUNGO0lBQ0QsV0FBVztJQUNYLFFBQVEsRUFBRTtRQUNSLE1BQU0sRUFBRTtZQUNOLEVBQUUsRUFBRSxPQUFPO1lBQ1gsR0FBRyxFQUFFLFlBQVk7WUFDakIsR0FBRyxFQUFFLE1BQU07WUFDWCxHQUFHLEVBQUUsU0FBUztZQUNkLFVBQVUsRUFBRSxZQUFZO1lBQ3hCLFlBQVksRUFBRSxjQUFjO1lBQzVCLFNBQVMsRUFBRSxhQUFhO1lBQ3hCLFlBQVksRUFBRSxRQUFRO1NBQ3ZCO0tBQ0Y7Q0FDQSxDQUFDIn0=